import {Component, model, ModelSignal} from '@angular/core';
import {
  CSV_IMPORT_ACTION,
  DEFAULT_TABLE_ACTIONS,
  ITableAction,
  TableControlComponent,
  TableControlModule,
} from 'frontier';
import AppControlGuids from '../../../../api/ControlGuids';

@Component({
  selector: 'app-invoice-automation-import',
  standalone: true,
  imports: [TableControlModule],
  templateUrl: '../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.html',
  styleUrl: '../../../../../../projects/frontier/browserkit/src/lib/components/control/table-control/table-control.component.scss',
})
export class InvoiceAutomationImportComponent extends TableControlComponent {
  override GUID: string = AppControlGuids.TInvoiceAutomationImportView;
  override actions: ModelSignal<ITableAction[]> = model<ITableAction[]>([
    ...DEFAULT_TABLE_ACTIONS,
    CSV_IMPORT_ACTION,
  ]);
}
